import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {PlayerConfigurationEdit} from '../models/player-configuration';
import {LoadPlayerConfigurationEditSuccessAction, playerConfigurationEditActionTypes} from '../actions/player-configuration-edit';
import {playerConfigurationUpdateActionTypes, UpdatePlayerConfigurationSuccessAction} from '../actions/player-configuration-update';

export interface PlayerConfigurationEditState {
  array: PlayerConfigurationEdit[];
}

const initialState: PlayerConfigurationEditState = {
  array: []
};

export function playerConfigurationEditReducer(state: PlayerConfigurationEditState = initialState, action: Action): PlayerConfigurationEditState {
  switch (action.type) {
    case playerConfigurationEditActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case playerConfigurationEditActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case playerConfigurationUpdateActionTypes.UPDATE_SUCCESS:
      return handleUpdateSuccessAction(state, action);
    case playerConfigurationEditActionTypes.CLEAR:
      return handleLoadClearAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: PlayerConfigurationEditState, action: LoadPlayerConfigurationEditSuccessAction): PlayerConfigurationEditState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleUpdateSuccessAction(state: PlayerConfigurationEditState, action: UpdatePlayerConfigurationSuccessAction): PlayerConfigurationEditState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: PlayerConfigurationEditState): PlayerConfigurationEditState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}
function handleLoadClearAction(state: PlayerConfigurationEditState): PlayerConfigurationEditState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const playerConfigurationEditSelectors = {
  array: (state: PlayerConfigurationEditState) => _.get(state, 'array', [])
};
